import React, { useState } from 'react';
import { Grid, Card, CardContent, Divider, makeStyles, Typography, Tabs, Tab, Box } from '@material-ui/core';
import { deliveryDate } from 'pages/ManagerRegistrationsPage';
import { parseDate, getFullRegistrationStatus } from '../consents/ConsentsTable';

const useStyles = makeStyles(() => {
  return {
    subtitle: {
      margin: '0px 0px 5px 5px',
      color: 'rgb(100, 141, 174)',
      fontSize: 24,
    },
    borderedTypography: {
      border: '1px solid',
      borderColor: '#8fadce',
      padding: '5px',
    },

    customTabs: {
      '& .MuiTab-root': {
        fontSize: '18px',
        color: 'rgb(100, 141, 174)',
      },
    },
    tabRoot: {
      marginLeft: '8px',
      textTransform: 'none',
      backgroundColor: '#ffffff',
      fontSize: '16px',
      color: 'rgb(100, 141, 174)',
      border: '1px solid #ccc',
      minWidth: 180,
      '&:hover': {
        color: '#ffffff',
        backgroundColor: 'rgb(100, 141, 174)',
        opacity: 1,
      },
      '&$tabSelected': {
        color: '#ffffff',
        backgroundColor: 'rgb(100, 141, 174)',
        fontWeight: 'bold',
        fontSize: '18px',
      },
    },
    tabSelected: {},
  };
});

// formatting the data field
function FieldItem({ title, field }) {
  const classes = useStyles();

  return (
    <>
      <Typography variant='subtitle1'>
        {title}
      </Typography>
      <Typography
        className={ classes.borderedTypography }
        variant='h6'
        style={ { marginBottom: '10px', minHeight: '45px' } }
        fullWidth
      >
        {field }
      </Typography>
      <Divider />
    </>
  );
}

// for tabs selection
function a11yProps(index) {
  return {
    id: `simple-tab-${ index }`,
    'aria-controls': `simple-tabpanel-${ index }`,
  };
}

// Function for Tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={ value !== index }
      id={ `simple-tabpanel-${ index }` }
      aria-labelledby={ `simple-tab-${ index }` }
      { ...other }
    >
      {value === index && (
        <Box p={ 3 }>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

// Component
function ManagersRegistrationsDetails({ kit }) {
  const classes = useStyles();
  const [ tab, setTab ] = useState(0);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  // format register from
  let register = '';
  if (kit === undefined) {
    register = '';
  } else if (kit?.business !== null) {
    register = 'Corporate';
  } else if (kit?.doctor !== null) {
    register = 'Doctor';
  } else if (kit?.business === null && kit?.doctor === null) {
    register = 'Individual';
  }

  return (
    <Box pt={ 2 }>
      <Box p={ 2 }>
        <Typography variant='h5'>
          {'Registered from: '}
          <span>{register}</span>
        </Typography>
      </Box>
      <Tabs
        className={ classes.customTabs }
        value={ tab }
        onChange={ handleChange }
        aria-label='simple tabs example'
        indicatorColor='primary'
      >
        <Tab
          label='Basic Info'
          { ...a11yProps(0) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        />
        <Tab
          label='Invitations'
          { ...a11yProps(1) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        />
      </Tabs>
      <TabPanel value={ tab } index={ 0 }>
        <Grid container spacing={ 3 }>
          {kit?.doctor !== null
                    && (
                      <Grid item xs={ 12 }>
                        <Card>
                          <CardContent>
                            <Grid container spacing={ 3 }>
                              <Grid item xs={ 12 }>
                                <Typography
                                  variant='h5'
                                  className={ classes.subtitle }
                                >
                                  Doctor Details
                                </Typography>
                              </Grid>
                              <Grid item xs={ 6 }>
                                <FieldItem
                                  title='Last Name'
                                  field={ kit?.doctor?.family_name }
                                />

                              </Grid>
                              <Grid item xs={ 6 }>
                                <FieldItem
                                  title='First Name'
                                  field={ kit?.doctor?.name }
                                />
                              </Grid>
                              <Grid item xs={ 12 }>
                                <FieldItem
                                  title='Email'
                                  field={ kit?.doctor?.email }
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    )}
          {kit?.business !== null && (
            <Grid item xs={ 12 }>
              <Card>
                <CardContent>

                  <Typography
                    variant='h5'
                    className={ classes.subtitle }
                  >
                    Corporate Details
                  </Typography>
                  <FieldItem
                    title='Brand Name'
                    field={ kit?.business?.brand_name }
                  />
                  <FieldItem
                    title='Email'
                    field={ kit?.business?.email }
                  />
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
        <Grid container spacing={ 3 }>
          <Grid item xs={ 6 }>
            <Card>
              <CardContent>
                <Typography
                  variant='h5'
                  className={ classes.subtitle }
                >
                  Registration
                </Typography>

                <FieldItem
                  title='Registration Status'
                  field={ typeof kit?.registrationStatus === 'string' ? getFullRegistrationStatus(kit) : '' }
                />

                <FieldItem
                  title='Registration Done Date'
                  field={ parseDate(kit?.metadata?.registrationDoneDate) }
                />

              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={ 6 }>
            <Card>
              <CardContent>
                <Typography
                  variant='h5'
                  className={ classes.subtitle }
                >
                  Sample
                </Typography>
                <FieldItem
                  title='Sample Received Date'
                  field={ parseDate(kit?.metadata?.sampleReceivedDate) || <Typography color='textSecondary'>Not Found</Typography> }
                />
                <FieldItem
                  title='Sample Collection Date'
                  field={ parseDate(kit?.metadata?.sampleCollectionDate) || <Typography color='textSecondary'>Not Found</Typography> }
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={ 6 }>
            <Card>
              <CardContent>
                <Typography
                  variant='h5'
                  className={ classes.subtitle }
                >
                  Report
                </Typography>
                <FieldItem
                  title='Report language'
                  field={ (kit?.locale === 2 && 'el-GR') || (kit?.locale === 3 && 'en-US') }
                />
                <FieldItem
                  title='Planned Report Delivery Date'
                  field={ deliveryDate(kit) || <Typography color='textSecondary'>Not Found</Typography> }
                />
                <FieldItem
                  title='Report Upload Date'
                  field={ parseDate(kit?.pdf_received_date) || <Typography color='textSecondary'>Not Found</Typography> }
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={ tab } index={ 1 }>
        <Grid container spacing={ 3 }>
          {Array.isArray(kit?.invitations) && typeof kit?.invitations[0]?.status === 'string' && kit?.invitations.map((invitation) => {
            const space = ' ';
            return (
              <Grid item xs={ 6 } key={ kit.id }>
                <Card>
                  <CardContent>
                    <Typography variant='h5' className={ classes.subtitle }>
                      Invitation
                    </Typography>
                    <FieldItem
                      title='Invitation Type'
                      field={ invitation?.reason === 'pgx-doctor-consent' ? 'PGX Doctor Consent' : 'Healthcare Professional Share Results' }
                    />
                    <FieldItem
                      title='Invitation Status'
                      field={ invitation?.status.toUpperCase() || '' }
                    />
                    <FieldItem
                      title='Doctor Fullname who has been sent an invitation'
                      field={ invitation?.metadata?.firstName + space + invitation?.metadata?.lastName || '' }
                    />
                    <FieldItem
                      title='Doctor Specialty who has been sent an invitation'
                      field={ invitation?.metadata?.specialty || '' }
                    />
                    <FieldItem
                      title='Doctor Email who has been sent an invitation'
                      field={ invitation?.metadata?.email || '' }
                    />
                    <FieldItem
                      title='Doctor Business number who has been sent an invitation'
                      field={ invitation?.metadata?.businessNumber || '' }
                    />
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </TabPanel>
    </Box>
  );
}

export default ManagersRegistrationsDetails;
